import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './Additionally.module.css';
import { useAdditionally } from './useAdditionally';
import { MeasurementsBlock } from '../../../UI/MeasurementsBlock/MeasurementsBlock';

export const Additionally = memo(() => {
    const { addCard, additionallyList } = useAdditionally();

    return (
        <div className={classNames(cls.Additionally)}>
            <MeasurementsBlock
                buttonTitle={i18next.t('Additionally.return.buttonTitle')}
                title={i18next.t('Additionally.return.title')}
                cards={additionallyList}
                onClick={addCard}
                type="additionally"
            />
        </div>
    );
});
